import { Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { DeleteDialogComponent, DeleteDialogData } from '../dialogs/delete-dialog/delete-dialog.component'

@Injectable({
  providedIn: 'root',
})
export class DeleteService {
  constructor(private dialog: MatDialog) {}

  openDialog(headerText: string, contentText: string): Observable<boolean> {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: {
        headerText,
        contentText,
      } as DeleteDialogData,
      minWidth: '250px',
      minHeight: '100px',
    })

    // Result is either false or true depending if user wants to delete the data
    return dialogRef.afterClosed().pipe(map(result => !!result))
  }
}
